module.exports = "<div class=\"dispatch-details\">\n   <ul class=\"nav nav-tabs\">\n       <li role=\"presentation\" ui-sref-active=\"active\"><a ui-sref=\"r.in.top.dispatch.applicator\">Applicator</a></li>\n       <li role=\"presentation\" ui-sref-active=\"active\"><a ui-sref=\"r.in.top.dispatch.hauler\">Hauler</a></li>\n       <li role=\"presentation\" ui-sref-active=\"active\"><a ui-sref=\"r.in.top.dispatch.mixer\">Mixer</a></li>\n   </ul>\n   <div class=\"blnd-tab-content\" ui-view></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dispatch/templates/dispatch.html
// module id = 646
// module chunks = 0